import { coreInstance } from "../index.js";
import router from "../../router/index.js";
export default {
  namespaced: true,
  state: {
    refeshToken: null,
    refeshProvince: null,
    refeshStoreID: null,
    accToken: null,
    userInfo: {},
    isSunmi: false
  },
  mutations: {
    verifyingToken(state, data) {
      state.userInfo = data;
      state.accToken = data.token;
    },
    getRefeshToken(state, data) {
      state.refeshToken = data.refeshToken;
      state.refeshProvince = data.province;
      state.refeshStoreID = data.storeID;
      state.isSunmi = data.isSunmi || false
    },
    setUserInfo(state, data) {
      state.userInfo.user_address = data.user_address;
      state.userInfo.user_email = data.user_email;
      state.userInfo.user_image = data.user_image;
      state.userInfo.user_first_name = data.user_first_name;
      state.userInfo.user_last_name = data.user_last_name;
    },
    setUserInfoReplace(state, data) {
      Object.assign(state.userInfo, data)
    }
  },
  actions: {
    fetchUserInfo({ state, commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        },
      };
      return coreInstance
        .get(
          `/api/v1/merChant/get_user_by_id/${state.userInfo.user_id}`,
          axiosConfig
        )
        .then((res) => {
          if (res.data.msg == false) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          } else {
            commit('setUserInfoReplace', res.data.data)
            return true;
          }
        })
        .catch(
          (err) =>
            (window.location = process.env.VUE_APP_MER_CORE_URL + "/signout")
        );
    },
    editUserInfo({ state, commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return coreInstance
        .put(
          "/api/v1/merChant/updateUserById/" + state.userInfo.user_id,
          form,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          commit("setUserInfo", { ...res.data.data, user_first_name: form.user_first_name, user_last_name: form.user_last_name });
          return true;
        })
        .catch(() => {
          return false
        });
    },
    async verifyingToken({ commit, dispatch }, configPath) {
      const axiosConfig = {
        headers: {
          Authorization: configPath.refeshToken,
        },
      };
      return coreInstance
        .get(
          "/api/v1/" +
          configPath.province +
          "/verifyToken/" +
          configPath.storeID,
          axiosConfig
        )
        .then((res) => {
          if (res.data.msg == false) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          } else {
            commit("setBaseAPIURL2", `${process.env.VUE_APP_BACKEND_URL_2}/api/v1/${configPath.province}/merChant/`, { root: true });
            commit("verifyingToken", res.data.data.domain, { root: true });
            commit("verifyingToken", res.data.data);
            commit("getRefeshToken", configPath);
            return true;
          }
        })
        .catch(
          (err) =>
            (window.location = process.env.VUE_APP_MER_CORE_URL + "/signout")
        );
    },
  },
  getters: {},
};
